/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Data_Controller_TextInputs */

const en_privacy_data_controller_text = /** @type {(inputs: Privacy_Data_Controller_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema is operated by EliteX GbR, based in Germany. This privacy policy is provided in German as the authoritative version. This English translation is for convenience only. For data protection inquiries, please contact us at`)
};

const de_privacy_data_controller_text = /** @type {(inputs: Privacy_Data_Controller_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema wird von der EliteX GbR mit Sitz in Deutschland betrieben. Für Datenschutzanfragen kontaktieren Sie uns bitte unter `)
};

const fr_privacy_data_controller_text = /** @type {(inputs: Privacy_Data_Controller_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema est exploité par EliteX GbR, basée en Allemagne. Pour les demandes de protection des données, veuillez nous contacter à `)
};

const es_privacy_data_controller_text = /** @type {(inputs: Privacy_Data_Controller_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema es operado por EliteX GbR, con sede en Alemania. Para consultas de protección de datos, contáctenos en `)
};

const it_privacy_data_controller_text = /** @type {(inputs: Privacy_Data_Controller_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema è gestita da EliteX GbR, con sede in Germania. Per richieste sulla protezione dei dati, contattaci all'indirizzo `)
};

const nl_privacy_data_controller_text = /** @type {(inputs: Privacy_Data_Controller_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema wordt beheerd door EliteX GbR, gevestigd in Duitsland. Neem voor vragen over gegevensbescherming contact met ons op via `)
};

const pl_privacy_data_controller_text = /** @type {(inputs: Privacy_Data_Controller_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema jest prowadzona przez EliteX GbR z siedzibą w Niemczech. W sprawach dotyczących ochrony danych prosimy o kontakt pod adresem `)
};

const fi_privacy_data_controller_text = /** @type {(inputs: Privacy_Data_Controller_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchemaa operoi EliteX GbR, jonka kotipaikka on Saksassa. Tietosuojakyselyissä ota yhteyttä osoitteeseen `)
};

const da_privacy_data_controller_text = /** @type {(inputs: Privacy_Data_Controller_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema drives af EliteX GbR med hjemsted i Tyskland. For databeskyttelseshenvendelser, kontakt os venligst på `)
};

const sv_privacy_data_controller_text = /** @type {(inputs: Privacy_Data_Controller_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema drivs av EliteX GbR, baserat i Tyskland. För dataskyddsfrågor, vänligen kontakta oss på `)
};

/**
* | output |
* | --- |
* | "Alchema is operated by EliteX GbR, based in Germany. This privacy policy is provided in German as the authoritative version. This English translation is for ..." |
*
* @param {Privacy_Data_Controller_TextInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const privacy_data_controller_text = /** @type {((inputs?: Privacy_Data_Controller_TextInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Data_Controller_TextInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_privacy_data_controller_text(inputs)
	if (locale === "fr") return fr_privacy_data_controller_text(inputs)
	if (locale === "es") return es_privacy_data_controller_text(inputs)
	if (locale === "it") return it_privacy_data_controller_text(inputs)
	if (locale === "nl") return nl_privacy_data_controller_text(inputs)
	if (locale === "pl") return pl_privacy_data_controller_text(inputs)
	if (locale === "fi") return fi_privacy_data_controller_text(inputs)
	if (locale === "da") return da_privacy_data_controller_text(inputs)
	if (locale === "sv") return sv_privacy_data_controller_text(inputs)
	return en_privacy_data_controller_text(inputs)
});